import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { SystemSearchPreset } from "@app/models/rest/system-search-preset";

@Injectable({
  providedIn: "root"
})
export class SystemSearchPresetRestService extends HateoasResourceOperation<SystemSearchPreset> {
  constructor() {
    super(SystemSearchPreset);
  }
}
